
const userInfo = () => {
  const userinfo = localStorage.getItem('user')
  try { return JSON.parse(userinfo) } catch { return null }
}

export default userInfo
